// Datos simulados para la página de lavado de autos

export const carWashData = {
  hero: {
    title: "Detallado y Lavado Premium de Autos",
    subtitle: "Excelencia en Cada Detalle",
    description: "Experimente lo último en cuidado automotriz con nuestros servicios profesionales de detallado. Tratamos su vehículo con la precisión y cuidado que merece.",
    cta: "Reservar Servicio",
    backgroundImage: "https://images.unsplash.com/photo-1601929862217-f1bf94503333"
  },
  
  services: [
    {
      id: 1,
      title: "Detallado Premium",
      description: "Nuestra Especialidad - detallado completo exterior con productos premium. Corrección de pintura y Descontaminación de Pintura.",
      features: [
        "Lavado y encerado exterior completo",
        "Corrección y protección de pintura",
        "Detallado del compartimento del motor y chassis",
        "Restauración de faros"
      ],
      image: "https://customer-assets.emergentagent.com/job_shine-station-3/artifacts/qzm5kk8p_Cleaning_02.jpg",
      duration: "4-6 horas",
      featured: true
    },
    {
      id: 2,
      title: "Lavado Express",
      description: "Lavado exterior rápido y completo.",
      features: [
        "Lavado exterior a mano",
        "Limpieza y brillo de llantas",
        "Limpieza de ventanas",
        "Secado y aspirado rápido"
      ],
      image: "https://images.pexels.com/photos/372810/pexels-photo-372810.jpeg",
      duration: "30-45 minutos",
      featured: false
    },
    {
      id: 3,
      title: "Detallado Interior",
      description: "Restauración y protección interior integral. Desde la alfombra hasta el tablero, lo hacemos sentir como nuevo.",
      features: [
        "Aspirado y limpieza profunda",
        "Acondicionamiento de cuero",
        "Eliminación de manchas",
        "Eliminación de olores",
        "Restauración de tablero y molduras"
      ],
      image: "https://customer-assets.emergentagent.com/job_shine-station-3/artifacts/h5egbvp6_Cleaning_01.jpg",
      duration: "2-3 horas",
      featured: false
    },
    {
      id: 4,
      title: "Cambio de Aceite Premium",
      description: "Contamos con el mas amplio portafolio de lubricantes Castrol para los motores mas exigentes",
      features: [
        "Asesoramiento de viscosidades",
        "Filtración de Alto Rendimiento",
        "Filtración Original",
        "Filtración Standard"
      ],
      image: "https://customer-assets.emergentagent.com/job_shine-station-3/artifacts/xrl2pkh1_Castrol_02.webp",
      duration: "30-60 minutos",
      featured: false
    }
  ],
  
  aboutUs: {
    title: "Sobre Nosotros",
    subtitle: "Pasión por la Perfección",
    description: "Con más de 15 años de experiencia en el cuidado automotriz premium, hemos construido nuestra reputación ofreciendo resultados excepcionales y un servicio al cliente inigualable. Nuestro equipo de profesionales certificados en detallado utiliza solo los mejores productos y técnicas probadas para garantizar que su vehículo reciba el cuidado que merece.",
    mission: "Nuestra misión es proporcionar servicios de cuidado automotriz de la más alta calidad mientras construimos relaciones duraderas con nuestros clientes. Creemos que cada vehículo merece lucir lo mejor posible, y estamos comprometidos a hacer que eso suceda.",
    values: [
      {
        title: "Calidad Primero",
        description: "Nunca comprometemos la calidad de nuestro trabajo o los productos que usamos."
      },
      {
        title: "Enfocados en el Cliente",
        description: "Su satisfacción es nuestra máxima prioridad. Escuchamos y cumplimos."
      },
      {
        title: "Excelencia Profesional",
        description: "Técnicos certificados con capacitación continua y experiencia."
      },
      {
        title: "Atención al Detalle",
        description: "Cada centímetro de su vehículo recibe cuidado y atención meticulosos."
      }
    ],
    stats: [
      { number: "15+", label: "Años de Experiencia" },
      { number: "10,000+", label: "Clientes Satisfechos" },
      { number: "4.9/5", label: "Calificación Promedio" },
      { number: "100%", label: "Garantía de Satisfacción" }
    ],
    image: "https://customer-assets.emergentagent.com/job_shine-station-3/artifacts/fjx8ukgj_SmatDetailingUniversitypictures72.jpg"
  },
  
  contact: {
    title: "¿Listo para Experimentar Cuidado Premium?",
    subtitle: "Contáctenos hoy para programar su cita",
    phone: "+573044175754",
    email: "trushineonline@gmail.com",
    address: "Carrera 31 # 11-51 detrás de Alkosto Carrera 30",
    hours: {
      weekdays: "Lunes a Sábado: 7:30 AM - 6:00 PM",
      saturday: "",
      sunday: ""
    }
  },
  
  testimonials: [
    {
      id: 1,
      name: "Leonardo Jiménez",
      rating: 5,
      text: "Necesitaba lavar el motor para descartar un daño... Y la verdad ese lavado fue súper bueno, dejaron impecable cada parte tanto que en el taller mecánico no habían visto un motor tan limpio.",
      vehicle: ""
    },
    {
      id: 2,
      name: "Diego Carvajal",
      rating: 5,
      text: "Excelente servicio de lavado y detallado de Vehículos.",
      vehicle: ""
    },
    {
      id: 3,
      name: "Santiago Rodriguez",
      rating: 5,
      text: "Me gusta el Off-Road, deje mi camioneta extremadamente sucia con mucho barro y rayones, me la entregaron mejor que en el concesionario.",
      vehicle: ""
    }
  ]
};
